import * as React from "react"
import { useState } from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"

const Notify = () => {
    const [isToggled, setToggled] = useState(true);
    const toggleTrueFalse = () => setToggled(!isToggled);

    return (
        <Layout>
            <div style={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: 'center',
                background: "#FF7B73",
                padding: '50% 0',
            }}>
                <button style={{
                    color: "#FF7B73",
                    background: "white",
                    border: "1px solid white",
                    borderRadius: "10px"
                }}
                    onClick={toggleTrueFalse}>
                    {
                        isToggled
                            ?
                            <h3>Toggle me</h3>
                            :
                            <>
                                <h3>Thank You!</h3>
                                <h3>You will be notified!</h3>
                            </>
                    }
                </button>
            </div>
            <Seo title="Notify" />
        </Layout>
    )
}

export default Notify
